import { useContext } from "react";

import { OfflineContext } from "./OfflineContext.tsx";

export function useOfflineContext() {
  return useContext(OfflineContext);
}
